<template>
  <div>
    <page-main :tableData="tableData" :loading="loading" @reload="getData">
      <page-header ref="header" slot="header" />
    </page-main>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
export default {
  components: { PageMain, PageHeader },
  props: {
    evgPlanOrderCode: { type: String, default: '' },
  },
  mounted() {
    this.getData()
  },
  data() {
    return {
      tableData: [],
      loading: false,
    }
  },
  methods: {
    async getData() {
      this.loading = true
      const res =await this.$api
        .ecomEvgPlanOrderDetailSkuListApi({
          evgPlanOrderCode: this.evgPlanOrderCode,
        })
        .catch(() => null)
      if (res) {
        this.tableData = res.body.data || []
      }
      this.loading = false
    },
  },
}
</script>
